import api from "../http";


export const hasActiveSession = async (signal) => {
  try {
    const response  = await api.get('auth/session/status', { signal });
    if (response.status === 200) {
      localStorage.setItem("session_expires", response.data.session_expires)
      return response.data;
    }
    return false;
  } catch (error) {
    // Ignore abort errors
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      return false;
    }
    return false;
  }
};

export const logout = async () => {
  try {
    const response = await api.post('auth/logout');
    if (response.status === 200) {
      return response.data.url;
    }
  } catch {
    window.location.href = "/"
  } finally {
    localStorage.removeItem("session_expires")
  }
};


export const login = async () => {
  try {
    const response = await api.post("auth/login");
    if (response.status === 200){
      return response.data.url;
    }
  } catch {
    throw new Error('Failed to initiate login process');
  }
};

